import { css } from 'styled-components';
import { getBaseTheme } from '@Themes';

const { spaces } = getBaseTheme();

export default css`
    h4 {
        padding-top: ${spaces.default.s};
    }
    div[class*='SelectTrigger'] {
        :focus {
            outline: none;
        }
    }
`;
